import React, { useState } from "react";
import Animations from "../../utilities/Animations";
import ScreenHeading from "../../utilities/ScreenHead/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import "./Resume.css";

const Resume = (props) => {
  const [selectBullet, setSelectBullet] = useState(0);
  const [carousalOff, setCarousalOff] = useState({});

  let fadeInScreenHand = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInscreen(props.id);
  };
  const fadeSub = ScrollService.currScreenFadeIn.subscribe(fadeInScreenHand);

  const ResumeHeading = (props) => {
    return (
      <div className="resumeHead">
        <div className="resumeMainHea">
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div>{props.fromDate + "_" + props.toDate}</div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resumeSubHead">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resumeHeadDesc">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  const resumeBullet = [
    { label: "React", logoSrc: "react.svg" },
    { label: "Node js", logoSrc: "nodejs.svg" },
    { label: "express", logoSrc: "express.svg" },
    { label: "CSS", logoSrc: "css.svg" },
    { label: "HTML", logoSrc: "html.svg" },
    { label: "Redux", logoSrc: "redux.svg" },
    { label: "JavaScript", logoSrc: "javascript.svg" },
    { label: "TypeScript", logoSrc: "typescript.svg" },
    { label: "Java", logoSrc: "java.svg" },
    { label: "MongoDB", logoSrc: "mongodb.svg" },
    { label: "Tailwind", logoSrc: "tailwindcss.svg" },
    { label: "Cypress", logoSrc: "cypress.png" },
  ];

  


  const handleCarousal = (index) => {
    let offSetHeight = 360;
    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offSetHeight * -1 + "px)" },
    };
    setCarousalOff(newCarousalOffset);
    setSelectBullet(index);
  };

  const getBullets = () => {
    return resumeBullet.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className= "bullet"
        key={index}
      >
        <img
          className="bulletLogo"
          src={require(`../../assests/resume/${bullet.logoSrc}`)}
          alt="no internet"
        />
        <p className="sLabel">{bullet.label}</p>
      </div>
    ));
  };


  return (
    <div className="resumeContainer" id={props.id || ""}>
      <div className="rParent">
        <ScreenHeading title={"Skills"} subHeading={"My Skills & Tech Stack"} />
        <div className="resumeCard">
          <div className="resumeBullet">
            <div className="bulletCont">
              <div className="bulletIcon"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
